import React from 'react';
import { Show, Tab, TabbedShowLayout, TextField } from 'react-admin';
import { DeviceShowActions } from '../actions';

export default ({ permissions, ...props }) => (
    <Show actions={<DeviceShowActions permissions={permissions} />} title='Device' {...props}>
        <TabbedShowLayout>
            <Tab label="Summary">
                <TextField label="EUI" source="eui" />
                <TextField source="destination" />
                <TextField source="group" />
                <TextField source="name" />
            </Tab>
            <Tab label="LoRa">
                <TextField label="Mode" source="lora.encryption.mode" />
                <TextField label="Network Server" source="lora.networkServer" />
                <TextField label="State" source="lora.state" />
                <TextField label="Version" source="lora.version" />
            </Tab>
            <Tab label="SIPP">
                <TextField label="Destination" source="sipp.destination" />
            </Tab>
            <Tab label="Subscription">
                <TextField label="Subscription" source="subscription.type" />
                <TextField label="Balance" source="subscription.balance" />
            </Tab>
        </TabbedShowLayout>
    </Show>
);
